/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ChatMessageAttachmentFileFileFromJSON(json) {
    return ChatMessageAttachmentFileFileFromJSONTyped(json, false);
}
export function ChatMessageAttachmentFileFileFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        url: json['url'],
        thumbnailImageUrl: !exists(json, 'thumbnail_image_url') ? undefined : json['thumbnail_image_url'],
        filename: json['filename'],
        humanizedFileSize: json['humanized_file_size']
    };
}
export function ChatMessageAttachmentFileFileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        url: value.url,
        thumbnail_image_url: value.thumbnailImageUrl,
        filename: value.filename,
        humanized_file_size: value.humanizedFileSize
    };
}
